import { useCallback, useEffect, useState } from 'react';

/** Odstęp między kolejnymi wysyłkami tej samej wiadomości (ochrona skrzynki i limitów Firebase). */
export const RESEND_SECONDS = 45;

/** Odliczanie do ponownej wysyłki: `remaining` > 0 = przycisk nieaktywny; `restart` po wysłaniu. */
export function useResendCountdown(seconds = RESEND_SECONDS) {
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const id = window.setTimeout(() => setRemaining((value) => value - 1), 1000);

    return () => window.clearTimeout(id);
  }, [remaining]);

  const restart = useCallback(() => setRemaining(seconds), [seconds]);

  return { remaining, restart };
}
